import { CommandBase } from "../../../common/services/cqs/commandManager";

export class SetGrotuttagCommand extends CommandBase {
    atgardId: number;
    grotuttagProduktionsplanerat: boolean;

    constructor(init: (instance: SetGrotuttagCommand) => void) {
        super("SetGrotuttagCommand");
        init(this);
    }
}
